import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
import { Utility } from "src/helpers/utility";

/**
 * Brand context for the non-color concerns of a brand: logo, feature flags,
 * and copy overrides. Colors flow purely through CSS variables (see
 * src/brands/apply-theme.js), so components never read colors from here.
 *
 * The active brand is resolved from `?brand=<id>` and is stable for the session.
 */
const BrandContext = createContext(null);

export function BrandProvider({ children }) {
  const brand = Utility.getBrand();

  return (
    <BrandContext.Provider value={brand}>
      {children}
    </BrandContext.Provider>
  );
}

BrandProvider.propTypes = {
  children: PropTypes.node,
};

/**
 * Read the active brand. Falls back to resolving from the URL if used outside a
 * BrandProvider (brand is URL-static, so the fallback is equivalent).
 */
export function useBrand() {
  return useContext(BrandContext) || Utility.getBrand();
}
